import { Component, OnInit } from "@angular/core";
import { CandidateListService } from "../../../shared/services/candidate-list/candidate-list.service";
import { Router, ActivatedRoute } from "@angular/router";
import { first } from 'rxjs/operators';
import { CoreService, AuthenticationService, QuestionBatchService } from 'src/app/shared';

@Component({
  selector: "app-candidate-details",
  templateUrl: "./candidate-details.component.html",
  styleUrls: ["./candidate-details.component.scss"]
})
export class CandidateDetailsComponent implements OnInit {
  testcenter: any;
  id: any;
  candidates: any;
  testcenterResult: any;

  photourl: any; 
  signurl:any;
  batches:any = [];
  metric_types:any = ['photo', 'left_finger', 
          'right_finger', 'left_IRIS', 'right_IRIS', 'rejected', 'right_finger_ISO', 'left_finger_ISO'];
  examDocs = [
    { docType: 'exam_photo', title: 'Exam Photo' },
    { docType: 'exam_left_thumb', title: 'Exam Left Thumb' },
    { docType: 'exam_right_thumb', title: 'Exam Right Thumb' },
    { docType: 'exam_left_iris', title: 'Exam Left IRIS' },
    { docType: 'exam_right_iris', title: 'Exam Right IRIS' },

    { docType: 'exam_right_thumb_iso', title: 'Exam Right Thumb ISO' },
    { docType: 'exam_left_thumb_iso', title: 'Exam Left Thumb ISO' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private coreService: CoreService,
    private auth: AuthenticationService, 
    private candidateListService: CandidateListService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.id = params.get("id");      
      this.getCandidateDetailsById();
      this.loadBatch (this.id);
    });
    
  }

  loadBatch (candidateid){
    this.candidateListService.getCandidateBatches (candidateid)
    .pipe (first())
    .subscribe (res=>{
      this.batches = res || [];
    });
  }

  handleTestCenters(e) {
    this.testcenter = e;
  }

  onSave() {
    this.candidateListService
      .saveTestCenters(this.id, this.testcenter)
      .pipe(first())
      .subscribe(res => {
        this.router.navigate(["manager/" + "candidate-list"]);
      });
  }

  getCandidateDetailsById() {
    this.candidateListService.getCandidatesById(this.id)
    .pipe(first())
    .subscribe(res => {
      if (res) {
        this.candidates = res;
        if (this.candidates.testcenter) {
          this.testcenterResult = this.candidates.testcenter;
        }
        this.initImageUrls (this.candidates['_id']);
      }
    });
  }

  onBack() {
    this.router.navigate(["manager/" + "candidate-list"]);
  }

  initImageUrls (id){

    this.photourl = this.getImgUrl (id , 'candidate_photo');
    this.signurl = this.getImgUrl (id , 'candidate_signature');
    //candidate_signature
  }


  getImgUrl(id, docType ) {
     
    var url = this.coreService.getRootPath() + "/documents/" + id + "/" + docType;
    url += "?appname=" + this.coreService.getAppName();
    url += "&usertype=" + this.coreService.getUserType();
    url += "&token=" + this.auth.getAuthToken();
    return url;
  }

  getDOB (c){
    var d = new Date (+c.dob_year, +c.dob_month -1, +c.dob_date);
    return d;
  }

}
